<template>
  <div class="ResumoCasamentoDetalhes">
    <div v-if="!!propCasamento.registro.transporte"
         class="col-12">
      <div class="row mt-2 mb-2 transporte">
        Existe Transporte - {{ 'Livro ' + propCasamento.registro.transporte.livro + ', fls. ' + propCasamento.registro.transporte.folha + '-' + propCasamento.registro.transporte.lado.toLowerCase() }}
      </div>
    </div>
    <div class="ResumoCasamentoDetalhes_header d-inline-flex justify-content-between align-items-center w-100 pt-2">
      <div class="col-5 d-inline-flex justify-content-between">
        <div class="mr-2">
          <p class="resumo-show_label p-0 m-0 my-2">
            Nome
          </p>
          <p class="resumo-show_sublabel p-0 m-0 mb-2">
            {{ propCasamento.registro.pessoas[0].nome_antigo }}
          </p>
        </div>
        <div>
          <p class="resumo-show_label p-0 m-0 my-2">
            Nome novo
          </p>
          <p class="resumo-show_sublabel p-0 m-0 mb-2">
            {{ propCasamento.registro.pessoas[0].nome }}
          </p>
        </div>
      </div>

      <div class="col-4">
        <div class="row">
          <div class="col-6 px-1">
            <Carga :prop-registro="propCasamento"
                   :prop-tipo-registro="propCasamento.registro.tipo_registro"
                   :prop-data-carga="data_carga"
                   @reload="reload" />
          </div>
          <div class="col-6 px-1">
            <ExportarXML :prop-registro-id="propCasamento.registro_id" />
          </div>
          <div id="transporte-casamento"
               class="col-6 px-1 mt-2">
            <button
              class="btn btn-outline-primary btn-block btn-sm"
              :disabled="!!propCasamento.registro.transporte"
              @click="gerarTransporte">
              Transporte
            </button>
          </div>
          <b-tooltip v-if="!!propCasamento.registro.transporte"
                     target="transporte-casamento">
            Este registro já foi transportado.
          </b-tooltip>
          <div class="col-6 px-1 mt-2">
            <button
              class="btn btn-secondary btn-block btn-sm btn-editar-obito-primary"
              @click="editarRegistro">
              Editar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="ResumoCasamentoDetalhes_body">
      <endereco-collapse :endereco="propCasamento.registro.pessoas[0].endereco || {}"
                         :ordem="1" />
      <genitores-collapse :genitores="propCasamento.registro.pessoas[0].genitores"
                          :ordem="1" />
      <registros-anteriores-collapse :registros-anteriores="propCasamento.registro.pessoas[0].registrosAnteriores"
                                     :ordem="1" />
      <documentos-collapse :documentos="propCasamento.registro.pessoas[0].documentos"
                           :ordem="1" />
      <collapse-default id="conjuge2">
        <template v-slot:header>
          Conjuge 2
        </template>
        <template v-slot:content>
          <div class="col-5 d-inline-flex justify-content-between">
            <div class="mr-2">
              <p class="resumo-show_label p-0 m-0 my-2">
                Nome
              </p>
              <p class="resumo-show_sublabel p-0 m-0 mb-2">
                {{ propCasamento.registro.pessoas[1].nome_antigo }}
              </p>
            </div>
            <div>
              <p class="resumo-show_label p-0 m-0 my-2">
                Nome novo
              </p>
              <p class="resumo-show_sublabel p-0 m-0 mb-2">
                {{ propCasamento.registro.pessoas[1].nome }}
              </p>
            </div>
          </div>
        </template>
      </collapse-default>
      <endereco-collapse :endereco="propCasamento.registro.pessoas[1].endereco || {}"
                         :ordem="2" />
      <genitores-collapse :genitores="propCasamento.registro.pessoas[1].genitores"
                          :ordem="2" />
      <registros-anteriores-collapse :registros-anteriores="propCasamento.registro.pessoas[1].registrosAnteriores"
                                     :ordem="2" />
      <documentos-collapse :documentos="propCasamento.registro.pessoas[1].documentos"
                           :ordem="2" />
      <dados-casamento-collapse :dados="propCasamento" />
      <local-casamento-collapse :local="propCasamento.registro.local" />
      <testemunhas-collapse :testemunhas="propCasamento.registro.partes" />
      <registro-collapse :prop-data="propCasamento" />
      <!-- <transporte-collapse v-if="!!propCasamento.registro.transporte"
                           :prop-data="propCasamento.registro.transporte" /> -->
    </div>

    <b-modal v-if="propNumeroPedidoPossueCertidaoEletronica"
             id="aviso-numero-pedido-possui-certidao-eletronica"
             size="md"
             hide-header
             hide-footer
             no-close-on-backdrop
             no-close-on-esc
             centered>
      <p class="mt-3">
        Já foi criada uma OS nº <strong style="font-size: 1.2rem;">{{ propPedidoPendente.numPedidoPossueOrdemServico.numero }}</strong> e gerada uma certidão eletrônica <a 
          :href="propPedidoPendente.numPedidoPossueCertidaoEletronica.link_assinatura"
          target="_blank" 
          rel="noopener noreferrer">
          <img 
            src="https://arpen-header-footer-prod.codebit.biz/assets/images/header/registro-civil-logo.svg" 
            alt="Abrir certidão eletrônica"
            style="height: 20px; vertical-align: middle;">
        </a> &nbsp; para o pedido nº <strong style="font-size: 1.2rem;">{{ propPedidoPendente.pedido_certidao_id }}</strong>.
      </p>
      <p>Deseja cumprir este pedido?</p>
      <div class="d-flex justify-content-end mt-4">
        <b-button
          class="btn-numero-pedido-possui-certidao-eletronica mr-3"
          @click="$bvModal.hide('aviso-numero-pedido-possui-certidao-eletronica'), $emit('fecharModalAvisoNumeroPedidoPossuiCertidaoEletronica', false, 'Sim')">
          Sim
        </b-button>
        <b-button
          style="background: #6c757d; border-color: #6c757d;"
          class="btn-numero-pedido-possui-certidao-eletronica"
          @click="$bvModal.hide('aviso-numero-pedido-possui-certidao-eletronica'), $emit('fecharModalAvisoNumeroPedidoPossuiCertidaoEletronica', false, 'Não')">
          Não
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  // components
  import Carga from '../Carga/Carga'
  import CollapseDefault from "@/components/SofiaRei/Resumo/Collapses/CollapseDefault"
  import GenitoresCollapse from "../Resumo/Collapses/GenitoresCollapse"
  import RegistroCollapse from "../Resumo/Collapses/RegistroCollapse"
  import EnderecoCollapse from "../Resumo/Collapses/EnderecoCollapse"
  import RegistrosAnterioresCollapse from "../Resumo/Collapses/RegistrosAnterioresCollapse"
  import DocumentosCollapse from "../Resumo/Collapses/DocumentosCollapse"
  import DadosCasamentoCollapse from "../Resumo/Collapses/DadosCasamentoCollapse"
  import LocalCasamentoCollapse from "../Resumo/Collapses/LocalCasamentoCollapse"
  import TestemunhasCollapse from "../Resumo/Collapses/TestemunhasCollapse"
  import TransporteCollapse from "@/components/SofiaRei/Resumo/Collapses/TransporteCollapse"
  import ExportarXML  from "@/components/ExportarXML"

  /* services */
  import CasamentoService from "@/services/Registros/Casamento"

  // outros
  import moment from 'moment'

  export default {
    name: 'ResumoCasamentoDetalhes',
    components: {
      Carga,
      CollapseDefault,
      GenitoresCollapse,
      RegistroCollapse,
      EnderecoCollapse,
      RegistrosAnterioresCollapse,
      DocumentosCollapse,
      DadosCasamentoCollapse,
      LocalCasamentoCollapse,
      TestemunhasCollapse,
      TransporteCollapse,
      ExportarXML
    },
    props: {
      propCasamento: {
        type: Object,
        default: () => ({})
      },
      propPedidoPendente: {type: Object, default: () => {}},
      propNumeroPedidoPossueCertidaoEletronica: { type: Boolean, default: false}
    },
    data () {
      return {
        dados: {
          registro: {
            livro: {}
          }
        },
        data_carga: null,
        nodeEnv: process.env.NODE_ENV
      }
    },
    watch: {
      propCasamento () {
        this.getDataCarga()
      }
    },
    mounted () {
      this.getDataCarga()
    },
    methods: {
      editarRegistro () {
        this.$router.push({name: 'editar_casamento', params: { id: this.propCasamento.casamento_id, propCasamento: this.propCasamento }})
      },
      reload () {
        this.$emit('reload', true)
      },
      getDataCarga () {
        if (!this.propCasamento.registro.data_carga) {
          this.data_carga = null
          return
        }

        const data = moment(this.propCasamento.registro.data_carga).format('DD/MM/YYYY')
        const hora = moment(this.propCasamento.registro.data_carga).format('H:mm').replace(':', 'h')

        this.data_carga = `Enviada ${data} ${hora}`
      },
      async gerarTransporte () {
        const res = await displayMessage('question', 'Deseja realizar o transporte deste registro?')

        if (res.value) { 
          try {
            loader({active: true, text: 'Gerando transporte...'})

            const registro = {
              ...this.propCasamento.registro,
              tipo_casamento: this.propCasamento.tipo_casamento
            }

            const res = await CasamentoService.transporte(registro)

            if (res) {
              displayMessage('success','Transporte realizado com Sucesso!').then(() => {
                this.reload()
              })
            }
          } catch (error) {
            console.error(error)
          } finally {
            loader({ text: "", active: false })
          } 
        }  
      }
    }
  }
</script>
<style lang="scss">
  .data-carga{
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    color: #373a3c;
    margin: 0;
  }
  .transporte {
      background: #00bdc5 ;
      color: #FFFFFF;
      padding: 2px;
      padding-left: 10px;
  }
  .btn-numero-pedido-possui-certidao-eletronica {
    padding: 0.2rem 2rem;
    border-radius: 4px;
    font-size: 1rem;
  }
</style>
